import * as ACTION_TYPES from "./actionTypes";
import { TransactionData } from "./reducer";

/**
 * Adding transactionId to store to initiate
 * thank you page navigation
 * @param {TransactionData} payload
 * @ignore
 */
export function updateNavigation(payload: TransactionData) {
    return {
        type: ACTION_TYPES.UPDATE_NAVIGATION_FOR_MULTIPLE_WARRANTIES,
        payload,
    };
}

/**
 * Store warrantyId under payment store object
 * @param {number} payload
 * @ignore
 */
export function initiateTransaction(payload) {
    return {
        type: ACTION_TYPES.INITIATE_TRANSACTION_FOR_MULTIPLE_WARRANTIES,
        payload,
    };
}

/**
 * Validate transaction by using id
 * @param {object} payload - contains transaction Id & status
 * @ignore
 */
export function validateTransaction(payload) {
    return {
        type: ACTION_TYPES.VALIDATE_TRANSACTION_FOR_MULTIPLE_WARRANTIES,
        payload,
    };
}

/**
 * Store validate transaction response
 * @param response
 * @ignore
 */
export function updateTransactionData(response) {
    return {
        type: ACTION_TYPES.UPDATE_TRANSACTION_DATA_FOR_MULTIPLE_WARRANTIES,
        payload: response,
    };
}

/**
 * Clear transaction response in store
 * @ignore
 */
export function clearTransactionData() {
    return {
        type: ACTION_TYPES.CLEAR_TRANSACTION_DATA_FOR_MULTIPLE_WARRANTIES,
    };
}

/**
 * Update transaction failed in store
 * @ignore
 */
export function updateTransactionFailed() {
    return {
        type: ACTION_TYPES.TRANSACTION_FAILED_FOR_MULTIPLE_WARRANTIES,
    };
}

/**
 * Update init transaction
 * @ignore
 */
export function updateInitTransaction() {
    return {
        type: ACTION_TYPES.UPDATE_INIT_TRANSACTION_FOR_MULTIPLE_WARRANTIES,
    };
}

/**
 * Update init transaction completed
 * @ignore
 */
export function updateInitTransactionCompleted() {
    return {
        type: ACTION_TYPES.UPDATE_INIT_TRANSACTION_COMPLETED_FOR_MULTIPLE_WARRANTIES,
    };
}

/**
 * Remove contractorId from persist data
 * @ignore
 */
export function removeContractorIdFromPersistData() {
    return {
        type: ACTION_TYPES.REMOVE_CONTRACTOR_ID_FROM_PERSIST_FOR_MULTIPLE_WARRANTIES,
    };
}
/**
 * Remove contractorId from persist data
 * @ignore
 */
export function addContractorIdFromPersistData(payload) {
    return {
        type: ACTION_TYPES.ADD_CONTRACTOR_ID_FROM_PERSIST_FOR_MULTIPLE_WARRANTIES,
        ...payload,
    };
}

/**
 * Update isAlreadyPaymentInitiated
 * @ignore
 */
export function updateIsAlreadyPaymentInitiated() {
    return {
        type: ACTION_TYPES.UPDATE_ALREADY_PAYMENT_INITIATED_FOR_MULTIPLE_WARRANTIES,
    };
}

/**
 * Generate Full warranty pdf report
 * @param {number} warrantyId
 * @ignore
 */
export function generateFullWarranty(warrantyId: number, warrantyNumber: any) {
    return {
        type: ACTION_TYPES.GENERATE_FULL_WARRANTY_FOR_MULTIPLE_WARRANTIES,
        payload: { warrantyId, warrantyNumber },
    };
}

export function generateFullWarrantyDownloaded() {
    return {
        type: ACTION_TYPES.GENERATE_FULL_WARRANTY_DOWNLOADED_FOR_MULTIPLE_WARRANTIES,
    };
}

/**
 * Generate Summary warranty pdf report
 * @param {object} payload
 * @ignore
 */
 export function generateSummaryWarranty(payload) {
    return {
        type: ACTION_TYPES.GENERATE_SUMMARY_WARRANTY_FOR_MULTIPLE_WARRANTIES,
        payload,
    };
}

export function generateSummaryWarrantyDownloaded() {
    return {
        type: ACTION_TYPES.GENERATE_SUMMARY_WARRANTY_DOWNLOADED_FOR_MULTIPLE_WARRANTIES,
    };
}

export function downloadAllWarranties() {
    return {
        type: ACTION_TYPES.DOWNLOAD_ALL_WARRANTIES,
    };
}

export function downloadAllWarrantiesSuccess() {
    return {
        type: ACTION_TYPES.DOWNLOAD_ALL_WARRANTIES_SUCCESS,
    };
}

export function downloadAllWarrantiesFailure() {
    return {
        type: ACTION_TYPES.DOWNLOAD_ALL_WARRANTIES_FAILURE,
    };
}
